const ITEMS = [
  "Cumplimiento normativo CNE",
  "Ciberseguridad resiliente",
  "Infraestructura de misión crítica",
  "Desarrollo de software electoral y regulado",
  "Redes de alta disponibilidad",
  "Transformación digital Occidente",
];

const Row = ({ ariaHidden }) => (
  <ul className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
    {ITEMS.map((item) => (
      <li key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-mono text-xs font-medium uppercase tracking-[0.28em] text-slate-400 sm:text-sm">
          {item}
        </span>
        <svg width="10" height="10" viewBox="0 0 10 10" className="shrink-0" aria-hidden="true">
          <rect x="2.2" y="2.2" width="5.6" height="5.6" transform="rotate(45 5 5)" fill="#00F0FF" />
        </svg>
      </li>
    ))}
  </ul>
);

const Marquee = () => (
  <section
    className="hairline-t hairline-b overflow-hidden border-l-0 border-r-0 bg-[#0D0F18] py-6"
    data-testid="marquee-section"
  >
    <div className="flex w-max animate-marquee">
      <Row ariaHidden={false} />
      <Row ariaHidden={true} />
    </div>
  </section>
);

export default Marquee;
